React = require 'react'
t = require('views/internal/recup-with-helpers')('marketing')
track = require 'debug/track'
trackUe = require 'debug/trackUe'
_ = require 'underscore'
$ = require 'jquery'
Promise = require 'bluebird'
Util = require 'lib/util'

module.exports = class MarketingComponent extends React.Component
  displayName: 'HeaderNotifications'

  constructor: ->
    this.state =
      visible: true
      stage: 'choose'

  render: t.renderable ->
    if !@state.visible
      return t.div()

    switch @state.stage
      when 'choose'
        @renderChoose()
      when 'done'
        @renderDone()
        Promise.delay(2000).then =>
          @setState(visible: false)

  renderDone: ->
    t.div '.marketing-opt-in-container', ->
      t.h2 '.marketing-opt-in-greeting', ->
        t.span '.icon-lg.icon-check'
        t.format 'got-it'

  renderChoose: ->
    onClickIn = (e) =>
      Util.stop(e)
      @submit(true)

    onClickOut = (e) =>
      Util.stop(e)
      @submit(false)

    t.div '.marketing-opt-in-container', ->

      t.h2 '.marketing-opt-in-greeting', ->
        t.format 'hey-there'

      t.p '.marketing-opt-in-question', ->
        t.format 'can-we-occasionally-send-you-marketing-emails-like'

      t.div '.marketing-opt-in-buttons', ->
        t.button '.button.primary', { onClick: onClickIn },
          -> t.format 'yep-im-in'
        t.button '.button.primary', { onClick: onClickOut },
          -> t.format 'no-thanks'

  submit: (optedIn) ->
    if optedIn
      trackUe('header', 'opt in to', 'marketing', 'member', '',
        'by clicking the opt-in button')
    else
      trackUe('header', 'opt out of', 'marketing', 'member', '',
       'by clicking the opt-out button')
    @props.setMarketingOptIn(optedIn)
    @setState(stage: 'done')



// WEBPACK FOOTER //
// ./app/scripts/views/marketing/marketing-opt-in-component.coffee